/**
 * Djiboutian franc.
 */
export var DJF = {
  code: 'DJF',
  base: 10,
  exponent: 0
};